import { Controller } from "@hotwired/stimulus"

// Shows the chosen file as a thumbnail before the form is saved.
export default class extends Controller {
  static targets = ["input", "preview"]

  show() {
    const file = this.inputTarget.files[0]
    if (this.previewTarget.src) URL.revokeObjectURL(this.previewTarget.src)

    if (file) {
      this.previewTarget.src = URL.createObjectURL(file)
      this.previewTarget.classList.remove("hidden")
    } else {
      this.previewTarget.removeAttribute("src")
      this.previewTarget.classList.add("hidden")
    }
  }

  disconnect() {
    if (this.previewTarget.src) URL.revokeObjectURL(this.previewTarget.src)
  }
}
